const getParentOverlayContainer = (
// eslint-disable-next-line @typescript-eslint/no-inferrable-types
selector = 'body') => {
    const container = document.querySelector(selector);
    if (!container) {
        console.warn(`Container with the selector "${selector}" is not found on the page. document.body is used instead`);
        return document.body;
    }
    else {
        return container;
    }
};

export { getParentOverlayContainer as g };
